// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.resident {
  --min-height: 72px;
  --padding-start: 16px;
  --inner-padding-end: 12px;
  --background-hover: var(--ion-color-primary);
  --background-hover-opacity: 0.04;
}
.resident__avatar {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 44px;
  height: 44px;
  margin-inline-end: 14px;
  border-radius: 50%;
  font-size: 15px;
  font-weight: 600;
  letter-spacing: 0.5px;
  color: var(--ion-color-medium-shade);
  background: rgba(var(--ion-color-medium-rgb), 0.14);
}
.resident__avatar--registered {
  color: var(--ion-color-primary);
  background: rgba(var(--ion-color-primary-rgb), 0.14);
}
.resident__avatar-badge {
  position: absolute;
  right: -2px;
  bottom: -2px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  border: 2px solid var(--ion-item-background, var(--ion-background-color, #fff));
  background: var(--ion-color-primary);
}
.resident__avatar-badge ion-icon {
  font-size: 11px;
  color: var(--ion-color-primary-contrast);
}
.resident__info {
  margin: 12px 0;
}
.resident__name {
  font-size: 15px;
  font-weight: 600;
  margin-bottom: 4px;
}
.resident__details {
  display: flex;
  flex-wrap: wrap;
  gap: 2px 16px;
  font-size: 13px;
  color: var(--ion-color-medium);
}
.resident__detail {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
}
.resident__detail ion-icon {
  flex-shrink: 0;
  font-size: 14px;
}
.resident__detail--mono {
  font-variant-numeric: tabular-nums;
  letter-spacing: 0.3px;
}
.resident__status {
  margin-inline-end: 8px;
  padding: 3px 10px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 500;
  white-space: nowrap;
  color: var(--ion-color-medium-shade);
  background: rgba(var(--ion-color-medium-rgb), 0.12);
}
.resident__status--registered {
  color: var(--ion-color-primary);
  background: rgba(var(--ion-color-primary-rgb), 0.12);
}
@media (max-width: 767px) {
  .resident__status {
    display: none;
  }
}
.resident__actions {
  display: flex;
  gap: 4px;
  margin: 0;
}
.resident {
  /* Neutral until hovered, so the rows stay calm; colour tells the action apart on hover */
}
.resident__action {
  display: grid;
  place-items: center;
  flex-shrink: 0;
  width: 38px;
  height: 38px;
  padding: 0;
  border: 0;
  border-radius: 50%;
  background: transparent;
  color: var(--ion-color-medium);
  line-height: 0;
  cursor: pointer;
  transition: background-color 0.15s ease, color 0.15s ease;
}
.resident__action ion-icon {
  display: block;
  font-size: 20px;
}
.resident__action--danger ion-icon {
  transform: translateX(-1px);
}
.resident__action:hover, .resident__action:focus-visible {
  color: var(--ion-color-primary);
  background: rgba(var(--ion-color-primary-rgb), 0.1);
  outline: none;
}
.resident__action--danger:hover, .resident__action--danger:focus-visible {
  color: var(--ion-color-danger);
  background: rgba(var(--ion-color-danger-rgb), 0.1);
}
.resident__swipe-icon {
  width: 28px;
  height: 28px;
  opacity: 0.5;
}

ion-item-option {
  min-width: 88px;
  font-size: 12px;
  text-transform: none;
}
ion-item-option ion-icon {
  font-size: 22px;
  margin-bottom: 4px;
}`, "",{"version":3,"sources":["webpack://./src/components/general components/resident/resident-component.scss","webpack://./src/components/general%20components/resident/resident-component.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,qBAAA;EACA,yBAAA;EACA,4CAAA;EACA,gCAAA;ACCF;ADCE;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,uBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,oCAAA;EACA,mDAAA;ACCJ;ADCI;EACE,+BAAA;EACA,oDAAA;ACCN;ADGE;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,+EAAA;EACA,oCAAA;ACDJ;ADGI;EACE,eAAA;EACA,wCAAA;ACDN;ADKE;EACE,cAAA;ACHJ;ADME;EACE,eAAA;EACA,gBAAA;EACA,kBAAA;ACJJ;ADOE;EACE,aAAA;EACA,eAAA;EACA,aAAA;EACA,eAAA;EACA,8BAAA;ACLJ;ADQE;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,YAAA;EACA,gBAAA;EACA,uBAAA;ACNJ;ADQI;EACE,cAAA;EACA,eAAA;ACNN;ADSI;EACE,kCAAA;EACA,qBAAA;ACPN;ADWE;EACE,sBAAA;EACA,iBAAA;EACA,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,oCAAA;EACA,mDAAA;ACTJ;ADWI;EACE,+BAAA;EACA,oDAAA;ACTN;ADaI;EAhBF;IAiBI,aAAA;ECVJ;AACF;ADaE;EACE,aAAA;EACA,QAAA;EACA,SAAA;ACXJ;ADlGA;EAgHE,yFAAA;ACXF;ADYE;EACE,aAAA;EACA,mBAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,SAAA;EACA,kBAAA;EACA,uBAAA;EACA,8BAAA;EACA,cAAA;EACA,eAAA;EACA,yDAAA;ACVJ;ADYI;EACE,cAAA;EACA,eAAA;ACVN;ADeI;EACE,2BAAA;ACbN;ADgBI;EAEE,+BAAA;EACA,mDAAA;EACA,aAAA;ACfN;ADkBI;EAEE,8BAAA;EACA,kDAAA;ACjBN;ADqBE;EACE,WAAA;EACA,YAAA;EACA,YAAA;ACnBJ;;ADuBA;EACE,eAAA;EACA,eAAA;EACA,oBAAA;ACpBF;ADsBE;EACE,eAAA;EACA,kBAAA;ACpBJ","sourcesContent":[".resident {\n  --min-height: 72px;\n  --padding-start: 16px;\n  --inner-padding-end: 12px;\n  --background-hover: var(--ion-color-primary);\n  --background-hover-opacity: 0.04;\n\n  &__avatar {\n    position: relative;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-shrink: 0;\n    width: 44px;\n    height: 44px;\n    margin-inline-end: 14px;\n    border-radius: 50%;\n    font-size: 15px;\n    font-weight: 600;\n    letter-spacing: 0.5px;\n    color: var(--ion-color-medium-shade);\n    background: rgba(var(--ion-color-medium-rgb), 0.14);\n\n    &--registered {\n      color: var(--ion-color-primary);\n      background: rgba(var(--ion-color-primary-rgb), 0.14);\n    }\n  }\n\n  &__avatar-badge {\n    position: absolute;\n    right: -2px;\n    bottom: -2px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 18px;\n    height: 18px;\n    border-radius: 50%;\n    border: 2px solid var(--ion-item-background, var(--ion-background-color, #fff));\n    background: var(--ion-color-primary);\n\n    ion-icon {\n      font-size: 11px;\n      color: var(--ion-color-primary-contrast);\n    }\n  }\n\n  &__info {\n    margin: 12px 0;\n  }\n\n  &__name {\n    font-size: 15px;\n    font-weight: 600;\n    margin-bottom: 4px;\n  }\n\n  &__details {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 2px 16px;\n    font-size: 13px;\n    color: var(--ion-color-medium);\n  }\n\n  &__detail {\n    display: inline-flex;\n    align-items: center;\n    gap: 5px;\n    min-width: 0;\n    overflow: hidden;\n    text-overflow: ellipsis;\n\n    ion-icon {\n      flex-shrink: 0;\n      font-size: 14px;\n    }\n\n    &--mono {\n      font-variant-numeric: tabular-nums;\n      letter-spacing: 0.3px;\n    }\n  }\n\n  &__status {\n    margin-inline-end: 8px;\n    padding: 3px 10px;\n    border-radius: 999px;\n    font-size: 12px;\n    font-weight: 500;\n    white-space: nowrap;\n    color: var(--ion-color-medium-shade);\n    background: rgba(var(--ion-color-medium-rgb), 0.12);\n\n    &--registered {\n      color: var(--ion-color-primary);\n      background: rgba(var(--ion-color-primary-rgb), 0.12);\n    }\n\n    // On narrow screens the avatar badge already tells the state: leave the room to the details\n    @media (max-width: 767px) {\n      display: none;\n    }\n  }\n\n  &__actions {\n    display: flex;\n    gap: 4px;\n    margin: 0;\n  }\n\n  /* Neutral until hovered, so the rows stay calm; colour tells the action apart on hover */\n  &__action {\n    display: grid;\n    place-items: center;\n    flex-shrink: 0;\n    width: 38px;\n    height: 38px;\n    padding: 0;\n    border: 0;\n    border-radius: 50%;\n    background: transparent;\n    color: var(--ion-color-medium);\n    line-height: 0;\n    cursor: pointer;\n    transition: background-color 0.15s ease, color 0.15s ease;\n\n    ion-icon {\n      display: block;\n      font-size: 20px;\n    }\n\n    // person-remove-outline is drawn right-heavy (person on the right, minus sign on the left):\n    // nudge it so it looks centred in the hover circle\n    &--danger ion-icon {\n      transform: translateX(-1px);\n    }\n\n    &:hover,\n    &:focus-visible {\n      color: var(--ion-color-primary);\n      background: rgba(var(--ion-color-primary-rgb), 0.1);\n      outline: none;\n    }\n\n    &--danger:hover,\n    &--danger:focus-visible {\n      color: var(--ion-color-danger);\n      background: rgba(var(--ion-color-danger-rgb), 0.1);\n    }\n  }\n\n  &__swipe-icon {\n    width: 28px;\n    height: 28px;\n    opacity: 0.5;\n  }\n}\n\nion-item-option {\n  min-width: 88px;\n  font-size: 12px;\n  text-transform: none;\n\n  ion-icon {\n    font-size: 22px;\n    margin-bottom: 4px;\n  }\n}\n",".resident {\n  --min-height: 72px;\n  --padding-start: 16px;\n  --inner-padding-end: 12px;\n  --background-hover: var(--ion-color-primary);\n  --background-hover-opacity: 0.04;\n}\n.resident__avatar {\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  width: 44px;\n  height: 44px;\n  margin-inline-end: 14px;\n  border-radius: 50%;\n  font-size: 15px;\n  font-weight: 600;\n  letter-spacing: 0.5px;\n  color: var(--ion-color-medium-shade);\n  background: rgba(var(--ion-color-medium-rgb), 0.14);\n}\n.resident__avatar--registered {\n  color: var(--ion-color-primary);\n  background: rgba(var(--ion-color-primary-rgb), 0.14);\n}\n.resident__avatar-badge {\n  position: absolute;\n  right: -2px;\n  bottom: -2px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 18px;\n  height: 18px;\n  border-radius: 50%;\n  border: 2px solid var(--ion-item-background, var(--ion-background-color, #fff));\n  background: var(--ion-color-primary);\n}\n.resident__avatar-badge ion-icon {\n  font-size: 11px;\n  color: var(--ion-color-primary-contrast);\n}\n.resident__info {\n  margin: 12px 0;\n}\n.resident__name {\n  font-size: 15px;\n  font-weight: 600;\n  margin-bottom: 4px;\n}\n.resident__details {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 2px 16px;\n  font-size: 13px;\n  color: var(--ion-color-medium);\n}\n.resident__detail {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.resident__detail ion-icon {\n  flex-shrink: 0;\n  font-size: 14px;\n}\n.resident__detail--mono {\n  font-variant-numeric: tabular-nums;\n  letter-spacing: 0.3px;\n}\n.resident__status {\n  margin-inline-end: 8px;\n  padding: 3px 10px;\n  border-radius: 999px;\n  font-size: 12px;\n  font-weight: 500;\n  white-space: nowrap;\n  color: var(--ion-color-medium-shade);\n  background: rgba(var(--ion-color-medium-rgb), 0.12);\n}\n.resident__status--registered {\n  color: var(--ion-color-primary);\n  background: rgba(var(--ion-color-primary-rgb), 0.12);\n}\n@media (max-width: 767px) {\n  .resident__status {\n    display: none;\n  }\n}\n.resident__actions {\n  display: flex;\n  gap: 4px;\n  margin: 0;\n}\n.resident {\n  /* Neutral until hovered, so the rows stay calm; colour tells the action apart on hover */\n}\n.resident__action {\n  display: grid;\n  place-items: center;\n  flex-shrink: 0;\n  width: 38px;\n  height: 38px;\n  padding: 0;\n  border: 0;\n  border-radius: 50%;\n  background: transparent;\n  color: var(--ion-color-medium);\n  line-height: 0;\n  cursor: pointer;\n  transition: background-color 0.15s ease, color 0.15s ease;\n}\n.resident__action ion-icon {\n  display: block;\n  font-size: 20px;\n}\n.resident__action--danger ion-icon {\n  transform: translateX(-1px);\n}\n.resident__action:hover, .resident__action:focus-visible {\n  color: var(--ion-color-primary);\n  background: rgba(var(--ion-color-primary-rgb), 0.1);\n  outline: none;\n}\n.resident__action--danger:hover, .resident__action--danger:focus-visible {\n  color: var(--ion-color-danger);\n  background: rgba(var(--ion-color-danger-rgb), 0.1);\n}\n.resident__swipe-icon {\n  width: 28px;\n  height: 28px;\n  opacity: 0.5;\n}\n\nion-item-option {\n  min-width: 88px;\n  font-size: 12px;\n  text-transform: none;\n}\nion-item-option ion-icon {\n  font-size: 22px;\n  margin-bottom: 4px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
